export default __webpack_public_path__ + "aa08365d77ce7d5a6cc1560229f35ec4.png";